export default {
  getUniqueID (){
    return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toLowerCase();
  },
  //
  getDateSpan(category, date){
    date = date || this.getDisplayDate()
    const from = this.getFirstDay(category, date);
    const to = this.getLastDay(category, date);

    return { from, to }
  },

  //Split display targetDate into integer parts
  getDateParts (targetDate){
    var [year, month, date] = targetDate.split('-');
    year = parseInt(year);
    month = parseInt(month) - 1;
    date = parseInt(date);

    return [year, month, date];
  },

  //
  getFirstDay(category, targetDate){
    var [year, month, date] = this.getDateParts(targetDate);
    if (category == 'weekly') {
      return this.getFirstDayOfWeek(year, month, date)
    }
    else if (category == 'monthly') {
      return this.getFirstDayOfMonth(year, month)
    }
    else if (category == 'quarterly') {
      return this.getFirstDayOfQuarter(year, month)
    }
  
  },

  //
  getLastDay (category, targetDate){
    var [year, month, date] = this.getDateParts(targetDate);

    if (category == 'weekly') {
      return this.getLastDayOfWeek(year, month, date)
    }
    else if (category == 'monthly') {
      return this.getLastDayOfMonth(year, month)
    }
    else if (category == 'quarterly') {
      return this.getLastDayOfQuarter(year, month)
    }
  
  },

  //month= 1-12
  getFirstDayOfWeek (year, month, date){
    const curDate = new Date(year, month, date);
    //Day of the week: 0 - 6
    var day = curDate.getDay();
    //ISO Standard first day of the week is Monday +1
    var from = date - day + 1;

    if (from > 0) {
      return this.getDisplayDate(year, month, from);
    }

    //Month 0 - 11
    if (month > 1) {
      month -= 1;
    }
    else {
      //December of Previous year
      month = 11;
      year -= 1;
    }

    const ndays = this.getNumberOfDays(year, month);
    from = ndays + from;

    return this.getDisplayDate(year, month, from);
  },

  //
  getLastDayOfWeek (year, month, date) {
    console.log('Last Day of Week from date:', year + '-' + month + '-' + date)
    const curDate = new Date(year, month, date);
    const ndays = this.getNumberOfDays(year, month);
    //ISO Standard last day of the week is Sunday +0
    //Day of the week: 0 - 6
    var day = curDate.getDay();
    //Date of end of week
    var to = date - day + 7;

    //We are still in same month of current year
    if (to <= ndays) {
      return this.getDisplayDate(year, month, to);
    }

    //Not December of current year
    if (month < 11) {
      month += 1;
    }
    else {
      //January next year
      month = 0;
      year += 1;
    }

    to = to - ndays;

    return this.getDisplayDate(year, month, to);
  },

  //
  getFirstDayOfMonth (year, month) {
    return this.getDisplayDate(year, month, 1);
  },

  //
  getLastDayOfMonth (year, month) {
    const ndays = this.getNumberOfDays(year, month)
  
    return this.getDisplayDate(year, month, ndays);
  },

  //
  getFirstDayOfQuarter (year, month) {
    const firstMonth = Math.floor(month / 3) * 3;
    return this.getDisplayDate(year, firstMonth, 1)
  },

  //
  getLastDayOfQuarter (year, month) {
    var lastMonth = Math.floor(month / 3) * 3 + 2;
    var lastDay = (month >= 3 && month < 9) ? 30 : 31;

    return this.getDisplayDate(year, lastMonth, lastDay);
  },

  //
  getNumberOfDays (year, month) {
    const isLeapYear = ((year % 4) == 0) ? true : false;
    const isEven = (month % 2) ? false : true;

    //February
    if (month == 1) {
      return isLeapYear ? 29 : 28;
    }
    else if ((isEven && month < 7) || (!isEven && month >= 7)) {
      return 31;
    }

    return 30;
  },

  //
  getDisplayDate (year, month, date) {

    if (isNaN(year) || isNaN(month) || isNaN(date)) {
      const curDate = new Date();
      year = curDate.getFullYear();
      //getMonth returns an Integer: 0-11
      month = curDate.getMonth();
      date = curDate.getDate();
    }

    month = (parseInt(month) + 1).toString().padStart(2, '0');
    date = parseInt(date).toString().padStart(2, '0');

    return year + '-' + month + '-' + date;
  },
  
  getDisplayDateFromTime(time) {
    var theDate=new Date(time);
      var year=theDate.getFullYear();
      var month=(theDate.getMonth()+1).toString().padStart(2, '0');
      var date=theDate.getDate().toString().padStart(2, '0')

      return `${year}-${month}-${date}`
  }

}
